import { render, staticRenderFns } from "./StrengthsWeaknesses.vue?vue&type=template&id=5e2f943e&scoped=true"
import script from "./StrengthsWeaknesses.vue?vue&type=script&lang=js"
export * from "./StrengthsWeaknesses.vue?vue&type=script&lang=js"
import style0 from "./StrengthsWeaknesses.vue?vue&type=style&index=0&id=5e2f943e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f943e",
  null
  
)

export default component.exports